import {useNavigate, useParams} from "react-router-dom";
import {useEffect, useState} from "react";
import associateServices from "../../services";
import Loading from "../../components/loading";
import store from "../../reducers/createReducers";
import AUTHENTICATION_ACTIONS from "../../actions/authentication-actions";

const TelegramAuth = () => {

    const navigate = useNavigate()
    let {token} = useParams()


    useEffect(() => {
        associateServices.authTelegram({
            token
        }).then(response => {
            if (response?.status === 200) {
                store.dispatch(AUTHENTICATION_ACTIONS.setUserToken(response?.data))
                navigate('/')
            } else {
                navigate('/')
            }
        })

    }, [token])


    return <Loading/>
}

export default TelegramAuth
